import angular from 'angular';
import { func } from 'prop-types';

angular.module('cxRelations').directive('cxRelBankAccounts', function() {
  return {
    restrict: 'E',
    template: require('./relBankAccounts.html'),
    scope: {
      field: '=',
      relation: '=',
      bankAccounts: '=data',
    },
    bindToController: true,
    controllerAs: 'vm',
    controller: [
      '$scope',
      'resourceFactorySvc',
      'flySvc',
      '$http',
      'ModalService',
      'enumCacheSvc',
      'translateListFilter',
      function(
        $scope,
        resourceFactorySvc,
        flySvc,
        $http,
        ModalService,
        enumCacheSvc,
        translateListFilter,
      ) {
        var resource = resourceFactorySvc.get('relationBankAccount');
        var vm = this;

        vm.countryEditorOpened = false;

        vm.datepickerOptions = {
          startingDay: 1,
        };
        vm.handleServerResponse = function(result) {
          if (result) {
            if (!vm.bankAccounts) vm.bankAccounts = [];
            result.forEach(data => {
              var bank = vm.bankAccounts.find(x => x.id === data.id);
              if (bank == null) {
                //Add bank
                vm.bankAccounts.push(data);
              } else {
                //Update bank
                angular.extend(bank, data);
              }
            });
            flySvc.success();
          }

          return false;
        };

        vm.addBank = function() {
          ModalService.showModal({
            template: require('../dialogs/addBankAccountDialog.html'),
            controller: 'AddBankAccountDialogCtrl',
            controllerAs: 'vm',
            locationChangeSuccess: false,
            inputs: {
              relation: vm.relation,
            },
          }).then(function(modal) {
            modal.element.modal();
            modal.element.on('hidden.bs.modal', function(e) {
              modal.element.off(e); //Remove event
              modal.element.remove(); //Remove element
            });
            modal.close.then(vm.handleServerResponse);
          });
        };
        vm.setAsMain = function(item) {
          if (!item) return;
          if (item.isMain) return; //Already main
          vm.update(item, 'isMain', true).then(function() {
            var oldMain = vm.bankAccounts.find(x => x.id !== item.id && x.isMain);
            if (oldMain) oldMain.isMain = false;
          });
        };

        vm.update = function(item, field, data) {
          //Validation error
          if (typeof data === 'undefined') return '';

          // No change
          if (angular.equals(item[field], data) && field !== 'countryCode') return false;

          var model = angular.copy(item);
          model[field] = data;
          if (field === 'iban') {
            model.countryCode = model.iban.substring(0, 2);
          }
          return resource.save(model).$promise.then(vm.handleServerResponse, function(error) {
            flySvc.error(error.data.code, error.data.parameters);
            return '';
          });
        };
        vm.delete = function(item) {
          if (!item || !item.id) return;
          resource.delete(
            { id: item.id, relationId: item.relationId },
            function(result) {
              const idx = vm.bankAccounts.indexOf(item);
              if (idx >= 0) vm.bankAccounts.splice(idx, 1);
              if (result) {
                //IsMain could have been changed, delete returns full list with updated values
                return vm.handleServerResponse(result);
              }
              flySvc.success();
            },
            function(error) {
              flySvc.error(error);
              return '';
            },
          ).$promise;
        };
        vm.setDomiciliation = function(item, checked) {
          if (!item || !item.id) return false;
          if (!checked) return vm.update(item, 'domiciliation', false);

          return resource
            .domiciliation({ id: item.id, relationId: item.relationId }, null)
            .$promise.then(vm.handleServerResponse, function(error) {
              flySvc.error(error);
              return '';
            });
        };
        vm.setPitRefund = function(item, checked) {
          if (!item || !item.id) return false;
          if (!checked) return vm.update(item, 'pitRefund', false);
          return resource
            .pitRefund({ id: item.id, relationId: item.relationId }, null)
            .$promise.then(vm.handleServerResponse, function(error) {
              flySvc.error(error);
              return '';
            }).$promise;
        };
      },
    ],
  };
});
